import { render, staticRenderFns } from "./LayoutLogin.vue?vue&type=template&id=85e43d10&scoped=true&"
import script from "./LayoutLogin.vue?vue&type=script&lang=js&"
export * from "./LayoutLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e43d10",
  null
  
)

export default component.exports